export default {
  "content": "<path d=\"M17.5 3.5a5 5 0 015 5v5a5 5 0 01-5 5H15v-2h2.5a3 3 0 003-3v-5a3 3 0 00-3-3h-11a3 3 0 00-3 3v5a3 3 0 003 3h3.12a2 2 0 011.328.505l4.216 3.747-1.328 1.495L9.62 18.5H6.5a5 5 0 01-5-5v-5a5 5 0 015-5h11z\" fill=\"#7B61FF\"/><path d=\"M12.5 11.5H15v2h-3.5a1 1 0 01-1-1V8h2v3.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};